module.exports = __webpack_public_path__ + "img/masterpass.53b82cdb.png";